import { Injectable } from '@angular/core';
import { AppConstants } from '@core/conf/app-constants';
import * as moment from 'moment';
import { Constants } from '../models/common/constants';
import { Preference } from '../models/user/preference';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  initPreference() {
    if (!this.preference) {
      this.preference = new Preference(Constants.DEFAULT_LANGUAGE_TYPE);
    }
  }

  setTimestamp() {
    this.ts = new Date().getTime();
  }

  private cacheDurationInHours() {
    const ts = moment(this.ts);
    const now = moment();
    return moment.duration(now.diff(ts)).asHours();
  }

  /**
   * this is the assumption we're making from now, if no timestamp or hash set
   * we assume cache is not loaded yet
   */
  get noCacheYet() {
    return !this.ts || !this.hash;
  }

  /**
   * cache expries in 12 hours
   */
  get cacheExpired() {
    const hours = this.cacheDurationInHours();
    return hours > AppConstants.CACHE_LIFESPAN_IN_HOURS;
  }

  // preference cache
  set preference(preference: Preference) {
    localStorage.setItem('user/preference', JSON.stringify(preference));
  }

  get preference() {
    const pref = localStorage.getItem('user/preference');
    return pref ? JSON.parse(pref.toString()) : undefined;
  }

  get en() {
    const enFile = localStorage.getItem('en.json');
    return enFile ? JSON.parse(enFile.toString()) : undefined;
  }

  set en(en: any) {
    localStorage.setItem('en.json', JSON.stringify(en));
  }

  get fr() {
    const frFile = localStorage.getItem('fr.json');
    return frFile ? JSON.parse(frFile.toString()) : undefined;
  }

  set fr(fr: any) {
    localStorage.setItem('fr.json', JSON.stringify(fr));
  }

  get ts() {
    const ts = localStorage.getItem('ts');
    return ts ? JSON.parse(ts.toString()) : undefined;
  }

  set ts(ts: any) {
    localStorage.setItem('ts', JSON.stringify(ts));
  }

  get hash() {
    const hash = localStorage.getItem('hash');
    return hash ? JSON.parse(hash.toString()) : undefined;
  }

  set hash(hash: any) {
    localStorage.setItem('hash', JSON.stringify(hash));
  }

}
